import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const DisabledGoogleCloudIcon = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_4310_4074)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M21.0305 10.2439L22.0555 10.2614L24.8405 7.47638L24.9755 6.29638C22.7665 4.32838 19.85 3.12988 16.663 3.12988C10.893 3.12988 6.02304 7.05588 4.58154 12.3739C4.88554 12.1619 5.53554 12.3209 5.53554 12.3209L11.1005 11.4059C11.1005 11.4059 11.3865 10.9324 11.5315 10.9559C12.1823 10.241 12.9752 9.6699 13.8594 9.27925C14.7437 8.88861 15.6998 8.68701 16.6665 8.68738C18.3165 8.69088 19.8365 9.27388 21.0305 10.2384V10.2439Z",
                        fill: "#282D3E"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M28.7516 12.3849C28.1051 9.99989 26.7726 7.89389 24.9741 6.29639L21.0306 10.2399C22.6106 11.5149 23.6241 13.4659 23.6241 15.6499V16.3459C25.5426 16.3459 27.1011 17.9079 27.1011 19.8229C27.1011 21.7414 25.5391 23.2999 23.6241 23.2999H16.6701L15.9741 23.9999V28.1729L16.6701 28.8654H23.6241C26.0212 28.8621 28.3192 27.9084 30.0143 26.2134C31.7094 24.5185 32.6632 22.2205 32.6666 19.8234C32.6631 16.7459 31.1166 14.0229 28.7516 12.3849Z",
                        fill: "#424960"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9.70911 28.87H16.6591V23.3H9.70911C9.21533 23.3001 8.72731 23.194 8.27811 22.989L7.27461 23.2965L4.48961 26.0815L4.24561 27.0215C5.81505 28.2188 7.7346 28.8669 9.70861 28.866L9.70911 28.87Z",
                        fill: "#5F6681"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9.709 10.7849C7.31188 10.7882 5.01389 11.7419 3.31882 13.4369C1.62375 15.1318 0.669943 17.4298 0.666504 19.8269C0.666504 22.7634 2.073 25.3744 4.2495 27.0284L8.2815 22.9964C7.67121 22.7212 7.15325 22.2758 6.78973 21.7137C6.42621 21.1515 6.23256 20.4964 6.232 19.8269C6.232 17.9084 7.794 16.3499 9.709 16.3499C11.119 16.3499 12.331 17.1999 12.879 18.3999L16.911 14.3679C15.2575 12.1914 12.646 10.7849 9.7095 10.7849H9.709Z",
                        fill: "#5F6681"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4310_4074",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "32",
                        height: "32",
                        fill: "white",
                        transform: "translate(0.666504)"
                    })
                })
            })
        ]
    });
};
export const ActiveGoogleCloudIcon = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_4310_3942)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M21.0305 10.2439L22.0555 10.2614L24.8405 7.47638L24.9755 6.29638C22.7665 4.32838 19.85 3.12988 16.663 3.12988C10.893 3.12988 6.02304 7.05588 4.58154 12.3739C4.88554 12.1619 5.53554 12.3209 5.53554 12.3209L11.1005 11.4059C11.1005 11.4059 11.3865 10.9324 11.5315 10.9559C12.1823 10.241 12.9752 9.6699 13.8594 9.27925C14.7437 8.88861 15.6998 8.68701 16.6665 8.68738C18.3165 8.69088 19.8365 9.27388 21.0305 10.2384V10.2439Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M28.7516 12.3849C28.1051 9.99989 26.7726 7.89389 24.9741 6.29639L21.0306 10.2399C22.6106 11.5149 23.6241 13.4659 23.6241 15.6499V16.3459C25.5426 16.3459 27.1011 17.9079 27.1011 19.8229C27.1011 21.7414 25.5391 23.2999 23.6241 23.2999H16.6701L15.9741 23.9999V28.1729L16.6701 28.8654H23.6241C26.0212 28.8621 28.3192 27.9084 30.0143 26.2134C31.7094 24.5185 32.6632 22.2205 32.6666 19.8234C32.6631 16.7459 31.1166 14.0229 28.7516 12.3849Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9.70911 28.87H16.6591V23.3H9.70911C9.21533 23.3001 8.72731 23.194 8.27811 22.989L7.27461 23.2965L4.48961 26.0815L4.24561 27.0215C5.81505 28.2188 7.7346 28.8669 9.70861 28.866L9.70911 28.87Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9.709 10.7849C7.31188 10.7882 5.01389 11.7419 3.31882 13.4369C1.62375 15.1318 0.669943 17.4298 0.666504 19.8269C0.666504 22.7634 2.073 25.3744 4.2495 27.0284L8.2815 22.9964C7.67121 22.7212 7.15325 22.2758 6.78973 21.7137C6.42621 21.1515 6.23256 20.4964 6.232 19.8269C6.232 17.9084 7.794 16.3499 9.709 16.3499C11.119 16.3499 12.331 17.1999 12.879 18.3999L16.911 14.3679C15.2575 12.1914 12.646 10.7849 9.7095 10.7849H9.709Z",
                        fill: "#FBBC05"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4310_3942",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "32",
                        height: "32",
                        fill: "white",
                        transform: "translate(0.666504)"
                    })
                })
            })
        ]
    });
};
export const DisabledGoogleCloudIconXS = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "20",
        viewBox: "0 0 24 20",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                opacity: "0.5",
                clipPath: "url(#clip0_104_14604)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.0301 5.75321L15.7864 5.76771L17.85 3.71862L17.9515 2.84872C16.7764 1.8013 15.353 1.07181 13.8165 0.729578C12.28 0.387343 10.6815 0.44374 9.1729 0.893403C7.66434 1.34307 6.29583 2.17106 5.19745 3.29868C4.09908 4.4263 3.30733 5.81608 2.89746 7.33594C3.1101 7.18129 3.59338 7.29728 3.59338 7.29728L7.70123 6.62069C7.70123 6.62069 7.91387 6.27273 8.01777 6.29448C8.89719 5.32824 10.1127 4.73472 11.4154 4.63544C12.7182 4.53616 14.0096 4.93864 15.0253 5.76046L15.0301 5.75321Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M20.7275 7.3431C20.2548 5.60569 19.2857 4.0438 17.939 2.84863L15.0394 5.74829C15.6369 6.22847 16.119 6.83662 16.4502 7.52791C16.7815 8.21921 16.9533 8.97602 16.9531 9.74257V10.2718C17.2908 10.2606 17.6273 10.3162 17.9435 10.4353C18.2596 10.5544 18.5491 10.7347 18.7955 10.9659C19.0418 11.1971 19.2402 11.4746 19.3791 11.7825C19.5181 12.0904 19.5949 12.4228 19.6052 12.7604C19.6156 13.0981 19.5592 13.4345 19.4393 13.7504C19.3194 14.0662 19.1384 14.3553 18.9067 14.6011C18.6749 14.8469 18.3969 15.0446 18.0887 15.1828C17.7804 15.321 17.4479 15.397 17.1102 15.4066H11.8087L11.2964 15.9237V18.9901L11.8087 19.5023H16.9435C18.3648 19.5001 19.7483 19.0441 20.8924 18.2006C22.0364 17.3571 22.8811 16.1703 23.3035 14.8132C23.7258 13.456 23.7037 11.9995 23.2404 10.6558C22.777 9.31207 21.8966 8.15146 20.7275 7.3431Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.67161 19.5023H11.8088V15.3945H6.67161C6.30555 15.3909 5.94456 15.3085 5.61324 15.1528L4.87382 15.38L2.81749 17.446L2.63867 18.1419C3.79722 19.0258 5.21441 19.5038 6.67161 19.5023Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.67146 6.1543C5.27428 6.15443 3.91239 6.59321 2.77792 7.40875C1.64344 8.22428 0.79363 9.3754 0.348358 10.6997C-0.0969131 12.0241 -0.115174 13.4548 0.296156 14.79C0.707487 16.1253 1.52764 17.2977 2.64094 18.142L5.61792 15.165C5.23613 14.9968 4.9011 14.7381 4.64185 14.4112C4.3826 14.0844 4.20695 13.6992 4.13011 13.2892C4.05327 12.8791 4.07757 12.4565 4.20089 12.058C4.32421 11.6594 4.54284 11.297 4.83784 11.002C5.13283 10.707 5.49531 10.4883 5.89385 10.365C6.2924 10.2417 6.715 10.2174 7.12505 10.2942C7.5351 10.3711 7.92024 10.5467 8.24709 10.806C8.57395 11.0652 8.83268 11.4003 9.00086 11.7821L11.9875 8.79299C11.3652 7.97264 10.5615 7.30751 9.63918 6.84972C8.71688 6.39193 7.70112 6.15391 6.67146 6.1543Z",
                        fill: "#FBBC04"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_104_14604",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "23.6177",
                        height: "19",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
export function GoogleCloudIcon(param) {
    let { isDisabled } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: isDisabled ? /*#__PURE__*/ _jsx(DisabledGoogleCloudIcon, {}) : /*#__PURE__*/ _jsx(ActiveGoogleCloudIcon, {})
    });
}
